import '@client-side-validations/client-side-validations';

window.ClientSideValidations.formBuilders['InfaktApp::FormBuilder'] = {
  add(element, settings, message) {
    element.parent().removeClass('error');
    element.parent().find('.invalid-feedback').remove();

    element.parent().addClass('error');
    element.parent().append(`<div class="invalid-feedback">${message}</div>`);
  },
  remove(element, settings) {
    element.parent().removeClass('error');
    element.parent().find('.invalid-feedback').remove();
  },
};
